import React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';

import s from './styles.css';
import { NBSP } from '../../constants/common';

const CONFIDENTIALITY_POLICY_URL = 'https://www.cian.ru/legal-documents/politika_konfidencialnosti_585';
const RULES_OF_USE_SERVICE_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/documents/pravila_polzovania_servisom.pdf';
const PROCESSING_OF_PERSONAL_DATA_URL =
  'https://static.cdn-cian.ru/frontend/mortgage-assets/documents/soglasie_na_PD.pdf';

export const AgreementBlock: React.FC = () => {
  return (
    <ArticleParagraph2>
      Нажимая «Подтвердить», я принимаю{NBSP}
      <a href={RULES_OF_USE_SERVICE_URL} target="_blank" className={s.link} rel="noreferrer">
        правила пользования сервисом
      </a>
      , соглашаюсь на{NBSP}
      <a href={PROCESSING_OF_PERSONAL_DATA_URL} target="_blank" className={s.link} rel="noreferrer">
        обработку персональных данных
      </a>
      {NBSP}и с{NBSP}
      <a href={CONFIDENTIALITY_POLICY_URL} target="_blank" className={s.link} rel="noreferrer">
        политикой конфиденциальности
      </a>
    </ArticleParagraph2>
  );
};
